import ClassificationsContainer from './Classifications.container';
export default ClassificationsContainer;